<app-view-title Title="" [showBack]="false" [showHeader]="false" [overlay]="true" ></app-view-title>
<div style="background: var(--accent-color); color: var(--main-color); width: 1000vw; height: 100vh; ">
  <view-content [centered]="true" [fullscreen]="true">
    <h1 style="padding: 25px 0; margin-top: 5rem;">{{ 'Intellitrailer.Home.OpenApp.lblHeadline1' | translate : 'Please go back to app' }}</h1>
    <p>{{ 'Intellitrailer.Home.OpenApp.lblMessage' | translate : 'It seems like you are navigated to browser. Please navigate back to app to continue.' }}</p>
    <img src="/Styles/{{appSettings.settings.theme}}/Logo.png" style="margin: 25px auto" />
  </view-content>
</div>

